import
{
    useL10n
} from "@ews/react-localization-context";

import
{
    IonButton,
    IonCard,
    IonCardContent,
    IonCardHeader,
    IonCardSubtitle,
    IonCardTitle,
    IonCol,
    IonContent,
    IonGrid,
    IonIcon,
    IonInput,
    IonItem,
    IonList,
    IonNote,
    IonPage,
    IonRow
} from "@ionic/react";

import
{
    CSSProperties,
    FC,
    FormEvent,
    PropsWithChildren,
    useState
} from "react";

import
{
    useAuth,
    useForgotPasswordRpc,
    useResetPasswordRpc
} from "./LoginProvider";

import { eye, eyeOff } from 'ionicons/icons';
import { Link } from "react-router-dom";
import { LegalModalContent, MoreInformation, useModal as oldUseModal } from "../Modal/useModal";
import { useNamedRoutes } from "../NamedRoutes";
import { LanguageSelector } from "../Navigation/Sidebar/Main";
import { useIsMobile } from "../Responsive";
import { TermsAndConditionsContent } from "../TermsAndConditionsModal/TermsAndConditionsModal";
import { getErrorText } from "./Login";
import loginStyle from './Login.module.scss';
import { useModal, ErrorModal, ShowErrorOptions } from "../Modal/Modal";


const minLength = 4;
const minDigits = 1;
const minUppercase = 1;
const minSpecialChars = 0;

const LoginPageWrapper: FC<PropsWithChildren & { title: string; }> = ({ children, title }) =>
{
    const { translate: t } = useL10n();
    const { openModal, modal } = oldUseModal();

    const mobileView = useIsMobile();
    const size = 50;

    const screenHeight = window.screen.height;

    //console.log("screenHeight: ", screenHeight);

    const logo: CSSProperties = {
        backgroundImage: "url('/assets/Hintergrund-Anmeldeseite-newREACT.jpg')",
        backgroundSize: "cover",
        backgroundPosition: `${size}% ${size}%`,
        backgroundRepeat: 'no-repeat',
        backgroundPositionY: mobileView ? "50px" : `0px`,
        height: "100%"
    };

    return (
        <IonPage>
            <IonContent
            >

                <div className={loginStyle.logoContainer}>
                    <div className={loginStyle.right}>
                        <img className={loginStyle.logo} src="assets/img/LST-Logo_LABORSTRAUSS-01.png" alt="logo" />
                    </div>
                    <div className={loginStyle.left}>
                        <img className={loginStyle.newREACTlogo} src="assets/img/newREACT-Schriftzug_blau_bold.png" alt="logo" />
                    </div>
                </div>

                <div
                    style={logo}
                >
                    <IonGrid className={loginStyle.backgroundLogo}>
                        <IonRow class="ion-justify-content-center"
                        //style={{ marginTop: `${screenHeight / 4}px` }}
                        >
                            <IonCol class="ion-align-self-center" size-md="8" size-lg="6" size-xl="4" size-sm="12">
                                <IonCard>
                                    <IonCardHeader>
                                        <IonCardTitle>{t(title)}</IonCardTitle>
                                        <IonCardSubtitle></IonCardSubtitle>
                                    </IonCardHeader>
                                    <IonCardContent>
                                        {children}
                                    </IonCardContent>
                                </IonCard>
                            </IonCol>
                        </IonRow>
                    </IonGrid>
                </div>
            </IonContent>
            {/* <IonToolbar> */}
            <div
                className={loginStyle.toolbar}
            >
                <span>
                    <button
                        onClick={() => openModal(<MoreInformation />)}
                        className={loginStyle.imprintButton}
                    >
                        {t('COM_FACPMANAGEMENT_FACP_MORE_INFORMATION')}
                    </button>
                </span>
                <span>
                    <button
                        onClick={() => openModal(<LegalModalContent />)}
                        className={loginStyle.imprintButton}
                    >
                        {t('[REACT_IMPRINT]')}
                    </button>
                </span>
                <span>
                    <button
                        onClick={() => openModal(
                            <div className={loginStyle.guideLinesCard}>
                                <TermsAndConditionsContent />
                            </div>
                        )}
                        className={loginStyle.imprintButton}
                    >
                        {t('[REACT_GUIDELINES]')}
                    </button>
                </span>
                <span>
                    <LanguageSelector lines="full" />
                </span>
            </div>
            {/* </IonToolbar> */}
            {modal}
        </IonPage>

    );
};

const LoginPage: FC = () =>
{
    const { translate: t } = useL10n();
    const { login } = useAuth();
    const { generate } = useNamedRoutes();

    //const [showPassword, setShowPassword] = useState(false);
    const [loginError, setLoginError] = useState('');

    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    const doLogin = async (username: string, password: string, e?: FormEvent<HTMLFormElement>) =>
    {
        if (e) e.preventDefault();

        try {
            await login(username, password);
        } catch (e) {
            console.error("Exception in doLogin during login call: ", e);
            const errorText = getErrorText(e as string);
            setLoginError(t(errorText));
        }
    };

    return (
        <LoginPageWrapper title="COM_LOGIN">
            <form onSubmit={(e) => doLogin(username, password, e)}>
                <IonList>
                    <IonItem>
                        <IonInput
                            name="username"
                            className="login-input"
                            type="text"
                            onIonInput={(e) => setUsername(e.target.value + '')}
                            labelPlacement="floating"
                            label={t('COM_FACPMANAGEMENT_USERS_USERID')}
                        />
                    </IonItem>

                    <IonItem>
                        <IonInput
                            name="password"
                            className="login-input"
                            type={showPassword ? "text" : "password"}
                            onIonInput={(e) => setPassword(e.target.value + '')}
                            labelPlacement="floating"
                            label={t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_LABEL')}
                        />
                        <IonButton fill="clear" onClick={() => setShowPassword(!showPassword)} slot="end">
                            <IonIcon icon={showPassword ? eyeOff : eye} />
                        </IonButton>
                    </IonItem>

                    <IonButton type="submit" className="ion-padding" expand="block">
                        {t('COM_LOGIN')}
                    </IonButton>

                    {loginError && <IonNote className={loginStyle.forgetPasswordContainer} color="danger">{loginError}</IonNote>}
                </IonList>

                <div className={loginStyle.forgetPasswordContainer}>

                    <Link to={generate('forgot-password')}>{t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL')}</Link>
                </div>
            </form>
        </LoginPageWrapper>
    );
};

const ForgotPasswordPage: FC = () =>
{
    console.log("rneder ForgotPasswordPage");
    const { translate: t } = useL10n();
    const forgotPassword = useForgotPasswordRpc();
    const { generate } = useNamedRoutes();

    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    const [username, setUsername] = useState("");

    const requestEmail = async (username: string, e?: FormEvent<HTMLFormElement>) =>
    {
        if (e) e.preventDefault();
        try {
            await forgotPassword(username);
            setDone(true);
        } catch (e) {
            const errorText = getErrorText(e as string);
            setError(t(errorText));
        }
    };

    return (
        <LoginPageWrapper title="COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL">
            {done ?
                <div>
                    <p>{t("COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL")}</p>
                    <Link to={generate('login')}>{t('[REACT_GOTO_REGITSTER]')}</Link>
                </div>
                :
                <form onSubmit={(e) => requestEmail(username, e)}>
                    <IonList>
                        <IonItem>
                            <IonInput name="username" className="login-input" type="text" onIonInput={(e) => setUsername(e.target.value + '')} labelPlacement="floating" label={t('COM_FACPMANAGEMENT_USERS_USERID')} />
                        </IonItem>

                        <IonButton type="submit" className="ion-padding" expand="block" >{t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL')}</IonButton>

                        {error && <IonNote color="danger">{error}</IonNote>}

                    </IonList>
                </form>
            }
        </LoginPageWrapper>
    );
};

export function validatePassword(password: string)
{
    const digitCount = (password.match(/[0-9]/g) || []).length;
    const uppercaseCount = (password.match(/[A-Z]/g) || []).length;
    const specialCharCount = (password.match(/[^A-Za-z0-9]/g) || []).length;

    const hasRequiredLength = password.length >= minLength;
    const hasRequiredDigitsChar = digitCount >= minDigits;
    const hasRequiredUppercaseChar = uppercaseCount >= minUppercase;
    const hasRequiredSpecialChars = specialCharCount >= minSpecialChars;

    return (
        hasRequiredLength &&
        hasRequiredDigitsChar &&
        hasRequiredUppercaseChar &&
        hasRequiredSpecialChars
    );
}


const InValidPasswordText = () =>
{
    const { translate: t } = useL10n();
    const PasswordHeader = `${t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_LABEL")}`;
    const PasswordLengthText = `${t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_MINIMUM_LENGTH_LABEL")} ${minLength}`;
    const PasswordDigitsText = `${t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_MINIMUM_DIGITS_LABEL")} ${minDigits}`;

    const PasswordSpecialCharsText = `${t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_MINIMUM_SPECIAL_CHARACTERS_LABEL")} ${minSpecialChars}`;
    const PasswordUppercaseText = `${t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_MINIMUM_CAPITALS_LABEL")} ${minUppercase}`;

    return (
        <div>
            <h3>{PasswordHeader}</h3>
            <ul>
                <li>{PasswordLengthText}</li>
                <li>{PasswordDigitsText}</li>
                <li>{PasswordSpecialCharsText}</li>
                <li>{PasswordUppercaseText}</li>
            </ul>
        </div>

    );
};




const ResetPasswordPage: FC<{ token?: string; }> = ({ token: tokenFromProps }) =>
{
    const { translate: t } = useL10n();
    const resetPassword = useResetPasswordRpc();
    const [error, setError] = useState('');
    const { generate, params } = useNamedRoutes();
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState<boolean>(false);
    const [done, setDone] = useState(false);
    const token = tokenFromProps ?? params().token;

    // const { openModal, modal } = useModal();



    const errorModal = useModal(ErrorModal, {
        closeOnBackdrop: true,
        closeOnEscape: true,
    });

    async function showError({
        message,
        title,
        error,
    }: ShowErrorOptions): Promise<void>
    {
        await errorModal.open({
            title,
            message,
            details:
                error == null
                    ? undefined
                    : error instanceof Error
                        ? error.message
                        : String(error),
            confirmText: "OK",
        });
    }


    const doResetPassword = async (password: string, e?: FormEvent<HTMLFormElement>) =>
    {
        if (e) e.preventDefault();

        if (!validatePassword(password)) {
            // alert("validatePassword");
            // openModal(<InValidPasswordText />);
            showError({
                title: t("COM_FACPMANAGEMENT_FORCE_PASSWORD_CHANGE_COMPLETE_PASSWORD_REQUIREMENTS_LABEL"),
                message: <InValidPasswordText />, //InValidPasswordTexts.map((x) => t(x)).join("\n")
            });
            return;
        };

        try {
            // alert("resetPassword");
            await resetPassword(token!, password);
            setDone(true);
            // showError({ message: "resetting worked" });


        } catch (e) {

            // alert("!eeeeeexception");


            const errorText = getErrorText(e as string);
            showError({
                title: t("COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL"),
                message: errorText
            });

            // setError(t(errorText));
        }
    };

    return (
        <LoginPageWrapper title="COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL">
            {done ?
                <div>
                    <p>{t("COM_FACPMANAGEMENT_RESET_COMPLETE_SUCCESS")}: <Link to={generate('login')}>{t('[REACT_HERE]')}</Link> an.</p>
                </div>
                :
                <form onSubmit={(e) => doResetPassword(password, e)}>
                    <IonList>
                        <IonItem>
                            <IonInput
                                name="username"
                                className="login-input"
                                type={showPassword ? "text" : "password"}
                                label={t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_LABEL')}
                                labelPlacement="floating"
                                onIonInput={(e) => setPassword(e.target.value + '')}
                            />
                            <IonButton fill="clear" onClick={() => setShowPassword(!showPassword)} slot="end">
                                <IonIcon icon={showPassword ? eyeOff : eye} />
                            </IonButton>
                        </IonItem>

                        <IonButton type="submit" className="ion-padding" expand="block" >{t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_RESET_LABEL')}</IonButton>

                        {error && <IonNote color="danger">{error}</IonNote>}

                    </IonList>
                </form >
            }
            {errorModal.element}
        </LoginPageWrapper >
    );
};



export default LoginPage;

export
{
    ForgotPasswordPage,
    ResetPasswordPage
};
